
import React, { useState, useEffect, useContext, useReducer } from 'react';
import { Table, Page } from '../../components';
import { default as ContractNew } from './ContractNew';
import { default as ContractDetail } from './ContractDetail';
import { download, insert, updateById, deleteById, insertGoods, getList, getListCount } from '../../services/Contract';
import { getListEnabled as getSupplierList } from '../../services/Supplier';
import {
  message,
  Tag,
  Button,
  Form,
  Progress, Modal
} from 'antd';
import {
  DownloadOutlined,
  ExclamationCircleOutlined,
  DeleteOutlined
} from '@ant-design/icons';

import './style';
import { MasterContext } from '../../App';
export default React.forwardRef((props, ref) => {
  const { user, currentUser,authorities } = useContext(MasterContext);
  const { title, visible, onClose } = props;
  const [isShowNew, setShowNew] = useState(false);
  const [isShowDetail, setShowDetail] = useState(false);
  const [isLoadding, setLoadding] = useState(false);
  const [clickedOrderId, setClickedOrderId] = useState('');
  const [isSingleSupplier, setSingleSupplier] = useState(true);
  const [addtionals, setAddtionals] = useState([]);
  const [isAddtionalInputVisible, setAddtionalInputVisible] = useState(false);
  const [form] = Form.useForm();
  const [shippingMark, setShippingMark] = useState('XXXX/99999\nNEW YORK\n1-UP\nMADE IN CHINA')
  const addAddtional = (e) => {
    const arr = [].concat(addtionals);
    if (e.target) {
      e.preventDefault();
      arr.push(e.target.value);
    } else {
      arr.push(e);
    }
    setAddtionals(arr);
    setAddtionalInputVisible(false);
  }
  const deleteAddtional = (e) => {
    const arr = [].concat(addtionals);
    arr.splice(e, 1);
    setAddtionals(arr);
  }

  const onNewCallback = async (id, value) => {
    try {
      const key = 'create_order_contract';
      console.log('onNewCallback:', id, value);
      message.loading({ content: '正在新建采购合同...', key });
      insert(id, value.order_contract).then(() => {
        insertGoods(id, value.order_contract_goods).then(() => {
          reloadContract().then(() => {
            setShowNew(false);
            message.success({ content: `新建采购合同成功`, key, duration: 2 });
          });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }


  const onSaveCallback = async (id, value) => {
    try {
      const key = 'update_order_contract';
      console.log('onSaveCallback:', id, value);
      message.loading({ content: '正在修改采购合同...', key });
      insert(id, value.order_contract).then(() => {
        insertGoods(id, value.order_contract_goods).then(() => {
          reloadContract().then(() => {
            setShowDetail(false);
            message.success({ content: `修改采购合同成功`, key, duration: 2 });
          });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onDeleteCallback = async (data) => {
    try {
      const key = 'delete_order_contract';
      console.log('onDeleteCallback:', data);
      message.loading({ content: `正在删除采购合同 ...`, key });
      const temp = [];
      for (let i = 0; i < data.length; i++) {
        temp.push(new Promise((resolve, reject) => {
          deleteById(data[i].order_id, data[i].supplier_ids.join(',')).then(() => resolve(true));
        }));
      }
      Promise.all(temp).then((data) => {
        reloadContract().then(() => {
          message.success({ content: `删除采购合同成功 `, key, duration: 2 });
        })
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const showDeleteConfirm = () => {
    const deleted = rows.filter(x => x.selected);
    const names = [];
    const ids = [];
    deleted.map((item) => {
      names.push(<div>{item.order_no} (#{item.po_code}) - [{item.supplier_name}]</div>);
      const exist = ids.find(x => x.order_id === item.order_id);
      if (exist) {
        exist.supplier_ids.push(item.supplier_id);
      } else {
        ids.push({ order_id: item.order_id, supplier_ids: [item.supplier_id] });
      }
    });
    Modal.confirm({
      title: '确定删除当前项目吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{names}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onDeleteCallback(ids)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onClickOrderId = (index) => {
    setClickedOrderId(index);
    setShowDetail(true);
  }
  const afterClose = (e) => {

  }
  const options = [
    {
      value: '贴102标签',
    },
    {
      value: 'Downing Street',
    },
    {
      value: 'Wall Street',
    },
  ];

  const setPage = (page, pageSize) => {
    dispatch({ type: 'pagination', data: { limit: pageSize, offset: (page - 1) * pageSize } });
  }

  const setSelected = (selected) => {
    dispatch({ type: 'selected', data: selected });
  }

  const initialState = {
    suppliers: [],
    total_rows: 50,
    rows: [],
    sort: { order: 'desc', sort: 'updated' },
    pagination: { limit: 10, offset: 0 },
    views: []
  };
  function reducer(state, action) {
    switch (action.type) {
      case 'suppliers':
        return Object.assign({}, state, { suppliers: action.data });
      case 'list':
        return Object.assign({}, state, { rows: action.data });
      case 'total_rows':
        return Object.assign({}, state, { total_rows: action.data });
      case 'pagination':
        return Object.assign({}, state, { pagination: action.data });
      case 'selected':
        const rows = state.rows;
        for (let i = 0; i < rows.length; i++) {
          if ((action.data || []).indexOf(i) > -1) {
            rows[i].selected = true;
          } else {
            rows[i].selected = false;
          }
        }
        return Object.assign({}, state, { rows: rows });
      case 'new':
        return { total: state.total + 1 };
      case 'edit':
        return { total: state.total };
      case 'delete':
        return { total: state.total - 1 };
      default:
        throw new Error();
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState);

  const reloadContract = () => {
    var p1 = new Promise((resolve, reject) => {
      getListCount().then(data => {
        dispatch({ type: 'total_rows', data: data });
        resolve(true);
      });
    });

    var p2 = new Promise((resolve, reject) => {
      getList(state.pagination).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    return Promise.all([p1, p2]).then(values => {
      //setLoadding(false);
    });
  }

  useEffect(() => {
    setLoadding(true);
    var p1 = new Promise((resolve, reject) => {
      getListCount().then(data => {
        dispatch({ type: 'total_rows', data: data });
        resolve(true);
      });
    });

    var p2 = new Promise((resolve, reject) => {
      getList(state.pagination).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    var p3 = new Promise((resolve, reject) => {
      getSupplierList().then(data => {
        dispatch({ type: 'suppliers', data: data });
        resolve(true);
      });
    });

    Promise.all([p1, p2, p3]).then(values => {
      setLoadding(false);
    });
  }, [state.pagination]);

  const { rows, suppliers, total_rows } = state;
  const downloadContract = () => {
    const selectedContracts = rows.filter(x => x.selected === true);
    for (let i = 0; i < selectedContracts.length; i++) {
      const contract = selectedContracts[i];
      download(contract.id).then(data => {
        const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
        const fileName = 'contract_' + new Date();
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);// 释放 URL对象
          document.body.removeChild(elink);
        }
      });
    }
  }

  const optionMenu = [
    <div>
      <Button onClick={showDeleteConfirm} type="danger" icon={<DeleteOutlined />}>
        <span style={{ padding: '0 1rem' }}>删除采购合同</span>
      </Button>
    </div>,
    <div>
      <Button onClick={downloadContract} style={{ backgroundColor: '#f0f0f0f' }} type="primary" icon={<DownloadOutlined />}>
        <span style={{ padding: '0 1rem' }}>下载供应商合同</span>
      </Button>
    </div>
  ];

  const contract = rows[clickedOrderId];
  return (
    <div style={{ padding: '0.5rem 1.5rem' }}  >
      <Table
        title="采购合同管理"
        newLabel="新建采购合同"
        showNewLabel={authorities.find(x=>x === 'create_contract') || currentUser.category_id === 1}
        setSelectedCallback={setSelected}
        setPageCallback={setPage}
        isLoadding={isLoadding}
        rows={rows}
        total_rows={total_rows}
        optionMenu={optionMenu}
        onNew={() => setShowNew(!isShowNew)} header={[
          {
            label: '合同编号', item: "order_no", align: 'center', sortable: true,
            render:
              (text, row, index) => {
                return <div><Button onClick={() => onClickOrderId(index)} style={{ padding: 0 }} type="link" size="small">{text}</Button></div>
              }
          },
          { label: 'PO编码', item: "po_code", align: 'center' },
          { label: '供应商', item: "supplier_name", sortable: true },
          { label: '签订日期', item: 'date', align: 'center' },
          { label: '合同金额', item: 'amount', align: 'right' },
          {
            label: '交货期限', item: 'delivery_deadline_date',
            render: (text, row, index) => {
              if (row.date_left < 15 && row.date_left > 0 && !row.delivery_date) return <div>{text}<Tag style={{ marginLeft: '0.25rem', padding: '0 0.25rem' }} size="small" color="#FF8C00">{row.date_left}天</Tag></div>
              else if (row.date_left <= 0 && !row.delivery_date) {
                return <div>{text}<Tag style={{ marginLeft: '0.25rem', padding: '0 0.25rem' }} size="small" color="#F50">{row.date_left}天</Tag></div>
              }
              else return <div>{text}</div>
            }
          },
          { label: '实际交货日期', item: 'delivery_date', align: 'center' },
          {
            label: '对接用户', item: 'owner_id', align: 'center', render: (text, row, index) => {
              return <div>{user.find(x => x.id === text).name}</div>
            }
          },
          {
            label: '发货状态', item: 'status', align: 'center', render: (text, row, index) => {
              if (row.delivery_date) {
                return <div>[已交货]</div>
              } else {
                return <Progress percent={80} steps={5} />
              }
            }
          },
          {
            label: '装箱单(箱-托)', item: 'package', align: 'right', render: (text, row, index) => {
              return <Button type="link" size="small">28箱-4托</Button>
            }
          },
          { label: '备注', item: 'addtionals' }
        ]} bordered={true} />
      <Page
        title="新建采购合同"
        width="80vw"
        body={<ContractNew suppliers={suppliers} onSaveCallback={onNewCallback} onCloseCallback={() => setShowNew(!isShowNew)} />}
        onCloseCallback={() => setShowNew(!isShowNew)}
        visible={isShowNew}
      />
      <Page
        title="采购合同详细"
        width="80vw"
        body={<ContractDetail contract={contract} onSaveCallback={onSaveCallback} suppliers={suppliers} />}
        onCloseCallback={() => setShowDetail(!isShowDetail)}
        afterClose={afterClose}
        visible={isShowDetail} />
    </div>

  );
});
